<div class="top-nav border-bottom" [ngClass]="isrtl() ? 'rtl' : 'ltr'"
     [class.menufull]="isFullMenu" [class.menuclosed]="isFullWidth">
  <nav class="navbar navbar-expand-sm">
    <div class="pl-0 login-info">
      <div class="logo" *ngIf="isFullMenu" (click)="goHome()">
        <img src="{{logo}}" alt="logo"/>
        <img *ngIf="merchantLogo && userType === 'merchant'" src="{{merchantLogo}}" alt="merchant-logo"/>
      </div>

      <div class="login-dates">
      <span>{{"general.lastsuccessfullogin" | translate }}
        <div class=" inline-div fixedNumberAr"> {{ lastLogin ? (lastLogin | date:'d MMM y | HH:mm z') : '-'}}</div>
      </span>
        <span class="login-dates-separator">--</span>
        <span class="half-opacity white-space-nowrap">{{"general.lastfailedlogin" | translate }}
          <div
            class=" inline-div fixedNumberAr">  {{ lastFailedLogin ? (lastFailedLogin | date:'d MMM y | HH:mm z') : '-'}}</div>
      </span>
      </div>
    </div>
  </nav>

  <div class="logout-menu" [class.direction-rtl]="isrtl()" [class.direction-ltr]="!isrtl()">
    <div class="foo-btn-outline-secondary langSwitch mt-1 mb-1" *ngIf="showLang" (click)='useLanguage();'>
      <span>{{ "menu.lang" | translate }} </span>
    </div>
    <ng-container *ngIf="checkList(deviceMenuTooltipItems)">
      <foo-tooltip-menu
        class="p-0"
        (onFunctionCalledEvent)="functionCalled($event)"
        [tooltipToggleIcon]="'foo-settings-secondary'"
        [items]="deviceMenuTooltipItems"
      ></foo-tooltip-menu>
      <span class="separator"></span>
    </ng-container>
    <ng-container *ngIf="checkList(menuItemsTooltipItems)">
      <foo-tooltip-menu
        class="p-0"
        (onFunctionCalledEvent)="functionCalled($event)"
        [tooltipToggleText]="personName"
        [tooltipToggleTextClass]="'username username-hide-on-mobile'"
        [tooltipToggleIcon]="'menu-arrow foo-arrow-down-secondary'"
        [items]="menuItemsTooltipItems"
      ></foo-tooltip-menu>
    </ng-container>
  </div>
</div>

